import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, MatSnackBar, MatDialog } from '@angular/material';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeptWhitelistDialogComponent } from './dept-whitelist-dialog.component';

@Component({
  selector: 'app-config-dept-whitelist',
  templateUrl: './config-dept-whitelist.component.html',
  styleUrls: ['./config-dept-whitelist.component.scss']
})
export class ConfigDeptWhitelistComponent implements OnInit {

  tableColumns: string[] = ['department_code', 'descripcion', 'estado', 'ACCION'];
  dataSource = new MatTableDataSource<any>([]);
  totalActivos = 0;
  totalInactivos = 0;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (!user || (user.idrol != 1 && user.idrol != 27)) {
      this.router.navigate(['/home']);
    }
    this.pageTitle.title = 'Catálogo de Box';
    this.cargarDatos();
  }

  cargarDatos() {
    this.spinner.show();
    this.gateway.get('getFallasDeptWhitelistListar', {}).then((result: any) => {
      const rows = result.rows || [];
      this.dataSource.data = rows;
      this.totalActivos = rows.filter(r => r.estado === 1).length;
      this.totalInactivos = rows.filter(r => r.estado === 0).length;
      this.spinner.hide();
    }).catch(() => {
      this.spinner.hide();
    });
  }

  agregar() {
    const dialogRef = this.dialog.open(DeptWhitelistDialogComponent, {
      width: '400px',
      data: { modo: 'crear', department_code: '', descripcion: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.gateway.save('getFallasDeptWhitelistCrear', {
          department_code: result.department_code,
          descripcion: result.descripcion
        }).then((res: any) => {
          this.spinner.hide();
          if (res.response === 1) {
            this.snackbar.open('Box creado exitosamente', 'Cerrar', { duration: 3000 });
            this.cargarDatos();
          } else {
            this.snackbar.open(res.message || 'Error al crear', 'Cerrar', { duration: 5000 });
          }
        }).catch(() => {
          this.spinner.hide();
          this.snackbar.open('Error al crear box', 'Cerrar', { duration: 5000 });
        });
      }
    });
  }

  editar(element) {
    const dialogRef = this.dialog.open(DeptWhitelistDialogComponent, {
      width: '400px',
      data: { modo: 'editar', department_code: element.department_code, descripcion: element.descripcion }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.gateway.save('getFallasDeptWhitelistActualizar', {
          id: element.id,
          department_code: result.department_code,
          descripcion: result.descripcion
        }).then((res: any) => {
          this.spinner.hide();
          if (res.response === 1) {
            this.snackbar.open('Box actualizado', 'Cerrar', { duration: 3000 });
            this.cargarDatos();
          } else {
            this.snackbar.open(res.message || 'Error al actualizar', 'Cerrar', { duration: 5000 });
          }
        }).catch(() => {
          this.spinner.hide();
        });
      }
    });
  }

  toggleEstado(element) {
    this.spinner.show();
    this.gateway.save('getFallasDeptWhitelistEliminar', {
      id: element.id,
      activar: element.estado === 0
    }).then((res: any) => {
      this.spinner.hide();
      if (res.response === 1) {
        this.snackbar.open(res.message, 'Cerrar', { duration: 3000 });
        this.cargarDatos();
      } else {
        this.snackbar.open(res.message || 'Error', 'Cerrar', { duration: 5000 });
      }
    }).catch(() => {
      this.spinner.hide();
    });
  }
}
